export default "__VITE_ASSET__ctmcG6yG__"